import { render, staticRenderFns } from "./GroupFilter.vue?vue&type=template&id=ffcaba66"
import script from "./GroupFilter.vue?vue&type=script&lang=js"
export * from "./GroupFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports